<template>
  <b-table
    responsive
    outlined
    :items="datos"
    :fields="tblColumFull"
    class="mb-0"
    show-empty
    empty-text="Aun no cuenta con aportaciones realizadas o validas."
    :busy="showLoading"
  >
    <!-- Column: Id -->
    <template #cell(id)="row">
      #{{ row.value }}
    </template>

    <!-- orden-ligada -->
    <template #cell(orden)="row">
      <span class="text-nowrap">
        {{ row.item.orden }}
      </span>
    </template>

    <!-- status-->
    <template #cell(status)="row">
      <b-badge :variant="frmstatus(row.item.status).color">
        {{ frmstatus(row.item.status).text }}
      </b-badge>
    </template>

    <!-- fecha pago -->
    <template #cell(fecha_pago)="row">
      <span class="text-nowrap">
        {{ row.item.fecha_pago }}
      </span>
    </template>

    <!-- ver factura -->
    <template #cell(factura)="row">
      <span class="text-nowrap">
        <b-badge
          :class="(row.item.factura) ? 'cursor-pointer' : '' "
          :variant="(row.item.factura) ? 'light-primary' : '' "
          @click="PrintFactura(row.item)"
        >{{ (row.item.factura) ? 'Ver Factura' : 'N/A' }}</b-badge>
      </span>
    </template>

    <template #table-busy>
      <div class="text-center text-warning my-2">
        <b-spinner class="align-middle" />
        <strong> Cargando...</strong>
      </div>
    </template>
  </b-table>
</template>

<script>
import {
  BTable,
  BSpinner,
  BBadge,
  // BLink,
} from 'bootstrap-vue'
import { ref, getCurrentInstance } from '@vue/composition-api'
import {
  shipcode,
} from '@core/utils/utils'
import hostname from '@core/utils/http/config-hostname'
import store from '@/store'
import {
  frmstatus,
} from '@core/utils/filter'

export default {
  components: {
    BTable,
    BSpinner,
    BBadge,
    // BLink,
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
  },
  setup() {
    // const toast = useToast()
    const showLoading = ref(false)
    const becasList = ref(null)
    const tblColumFull = ref([])
    const setTran = ref({})
    const vm = getCurrentInstance().proxy

    tblColumFull.value = [
      { key: 'id', label: '#', sortable: true },
      { key: 'orden' },
      { key: 'referencia' },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'formaPago' },
      {
        key: 'monto', label: 'Aportación', sortable: true, formatter: val => `$${val}`,
      },
      { key: 'fecha_pago', sortable: true },
      { key: 'comentarios' },
      { key: 'factura' },
      { key: 'observaciones' },
    ]

    // functions
    // preparar link for refresh
    const LinkReady = iden => {
      vm.$swal({
        html: 'Hola, usted saldra de la pantalla actual para ir a la solicitud',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No, mantenerme aqui.',
        confirmButtonText: 'Si, continuar',
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-warning mr-1',
        },
        reverseButtons: true,
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const routeData = `${hostname().host}/app/compras/${(store.state.cuenta.rolSelected.id !== 1) ? 'ordenes/preview' : 'preview'}/${shipcode(iden)}/`
          window.location.replace(routeData)
        }
      })
    }

    const PrintFactura = objTran => {
      if (objTran.factura !== null) {
        setTran.value = objTran
        const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
        const routeData = `${hostname().host}/app/imprimir/factura/${setTran.value.factura}/${setTran.value.orden}/${setTran.value.id}/`
        window.open(routeData, 'Imprimir Factura', config)
      }
    }

    /**
     * * muestra el comprobante que subio, proviene de un servicio delivery
     * Lo muestra en una ventana nueva
     * @param file ruta del archivo fisico en el server
     * TODO PROVIENE DE UN SERVICIO EXTERNO [ delivery ]
     */
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD + file}`, '_blank')
    }

    return {
      // functions
      LinkReady,
      frmstatus,
      PrintFactura,
      downloadFile,
      // values
      showLoading,
      becasList,
      tblColumFull,
    }
  },
}
</script>
